import { tv } from "tailwind-variants";
const autocompleteVariants = tv({
    slots: {
        listWrapperSlot: 'bg-neutral-1 absolute top-[52px] z-10 flex h-[370px] w-full flex-col rounded-xl shadow-md',
        overlayInputSlot: 'relative mt-1 grid w-full grid-cols-[48px_1fr] gap-3 px-4 pb-4'
    },
    variants: {
        isHidden: {
            true: {
                listWrapperSlot: 'hidden'
            }
        },
        isDrawer: {
            true: {
                listWrapperSlot: 'p-4 shadow-none'
            }
        }
    }
});
export { autocompleteVariants };
